export function SET_PROMISES_ORDERS (state, data) {
    state.promisesOrders = data.promiseorders
}

export function SET_PROMISES_REQUESTS (state, data) {
    state.promisesRequests = data.promiserequests
}